import { envsafe, str, num } from "envsafe";

export const env = envsafe({
  /**
   * Key for authenticating Mapbox maps.
   */
  NEXT_PUBLIC_MAPBOX_TOKEN: str({
    input: process.env.NEXT_PUBLIC_MAPBOX_TOKEN,
    devDefault: "_",
  }),
  /**
   * Key for authenticating VWorld.
   */
  NEXT_PUBLIC_VWORLD_KEY: str({
    input: process.env.NEXT_PUBLIC_VWORLD_KEY,
  }),
  /**
   * There's a separate host for websockets:
   * this points to it.
   */
  NEXT_PUBLIC_WS_HOST: str({
    input: process.env.NEXT_PUBLIC_WS_HOST,
    devDefault: "ws.placemark.io",
  }),
  /**
   * Limit for files at the frontend side.
   */
  NEXT_PUBLIC_FILE_LIMIT_MB: num({
    input: process.env.NEXT_PUBLIC_FILE_LIMIT_MB,
  }),
  /**
   * Warn people with files at least this big.
   */
  NEXT_PUBLIC_FILE_WARN_MB: num({
    input: process.env.NEXT_PUBLIC_FILE_WARN_MB,
  }),
  NEXT_PUBLIC_DOMAIN: str({
    input: process.env.NEXT_PUBLIC_DOMAIN,
    devDefault: "http://localhost:3000/",
  }),
  /**
   * Key for authenticating with Replicache
   * https://replicache.dev/
   */
  NEXT_PUBLIC_REPLICACHE_KEY: str({
    input: process.env.NEXT_PUBLIC_REPLICACHE_KEY,
    devDefault: "_",
  }),

  NEXT_PUBLIC_GOOGLE_CLIENT_ID: str({
    input: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
  }),
});
